<template>
    <!-- wrap -->
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <span>Face Mapping List</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <!-- gnb -->
        <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
        <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />
        <!-- // gnb -->

        <div id="content-wrap">
            <div id="contents">
                <!-- detail-wrapper -->
                <div class="detail-wrapper">
                    <div v-show="data.approveState !== 'request'" class="detail-box">
                        <div class="detail-header">
                            <a><span>결재현황</span></a>
                        </div>
                        <div class="detail-contents">
                            <div class="detail-subheader">
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th v-for="(item, index) in approvalList" :key="index">
                                                {{ index === 0 ? '기록자' : '확인자' }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td v-for="(item, index) in approvalList" :key="index">
                                                <span>{{ displayApproval(item) }}</span>
                                                <img
                                                    v-if="item.status === 'approval'"
                                                    :src="item.signUrl"
                                                    height="50px"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="data.approveState !== 'request'" class="btn-wrapper" style="margin-bottom: 61px;">
                        <button v-show="isSignCancelBtn" class="btn btn-delete align-right" @click="signCancel()">
                            <span>서명취소</span>
                        </button>
                        <button v-show="isSignBtn" class="btn btn-confirm align-right" @click="sign()">
                            <span>서명하기</span>
                        </button>
                    </div>
                    <div class="detail-box" :class="{ close: isCloseA }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseA }" @click="isCloseA = !isCloseA">
                                <span>막장평가표</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <div class="table-gap" />
                            <table class="border-weight-all">
                                <colgroup>
                                    <col style="width:15%" />
                                    <col style="width:45%" />
                                    <col style="width:15%" />
                                    <col style="width:25%" />
                                </colgroup>
                                <tr>
                                    <th colspan="4" class="large-title">
                                        <span>막장 평가표</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="inner-title">
                                        <span>현장명</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.constructionNameValue }}</span>
                                    </td>
                                    <th class="inner-title">
                                        <span>터널명</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.measureLocationName }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="inner-title">
                                        <span>위치</span>
                                    </th>
                                    <td class="inner-title">
                                        STA NO. <span>{{ data.station }}</span>
                                    </td>
                                    <th class="inner-title">
                                        <span>일자</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.investigationDay }} {{ data.investigationTime }}</span>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />
                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:50px" />
                                    <col style="width:130px" />
                                    <col style="width:100px" />
                                    <col style="width:auto" />
                                </colgroup>
                                <tr>
                                    <td rowspan="3">
                                        ⓛ
                                    </td>
                                    <td class="border-weight border-right">점하중강도<br />(MPa)</td>
                                    <td>10이상</td>
                                    <td colspan="5">
                                        4-10
                                    </td>
                                    <td colspan="4">
                                        2-4
                                    </td>
                                    <td colspan="2">
                                        1-2
                                    </td>
                                    <td colspan="4" rowspan="2">
                                        일축압축강도 사용
                                    </td>
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">
                                        슈미트햄머
                                    </td>
                                    <td>60이상</td>
                                    <td colspan="5">
                                        51-60
                                    </td>
                                    <td colspan="4">
                                        44-51
                                    </td>
                                    <td colspan="2">
                                        34-44
                                    </td>
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">일축압축강도<br />(MPa)</td>
                                    <td>250이상</td>
                                    <td colspan="5">
                                        100-250
                                    </td>
                                    <td colspan="4">
                                        50-100
                                    </td>
                                    <td colspan="2">
                                        25-50
                                    </td>
                                    <td colspan="2">
                                        5-25
                                    </td>
                                    <td>1-5</td>
                                    <td>1미만</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="score border-weight border-right">
                                        점수 (R1)
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-1"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">15</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-2"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">14</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-3"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">13</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-4"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">12</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-5"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">11</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-6"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">10</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-7"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">9</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-8"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">8</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-9"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">7</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-10"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">6</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-11"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">5</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-12"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">4</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-13"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">3</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-14"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">2</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-15"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">1</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="strengthIntackRockMaterialScore-16"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">0</span>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />

                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:180px" />
                                    <col style="width:auto" />
                                </colgroup>
                                <tr>
                                    <td class="border-weight border-right">
                                        ② 암질계수(%)
                                    </td>
                                    <td colspan="3">
                                        90-100
                                    </td>
                                    <td colspan="3">
                                        75-90
                                    </td>
                                    <td colspan="5">
                                        50-75
                                    </td>
                                    <td colspan="6">
                                        25-50
                                    </td>
                                    <td>25미만</td>
                                </tr>
                                <tr>
                                    <td class="score border-weight border-right">
                                        점수 (R2)
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-1" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">20</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-2" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">19</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-3" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">18</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-4" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">17</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-5" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">16</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-6" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">15</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-7" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">14</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-8" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">13</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-9" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">12</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-10" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">11</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-11" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">10</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-12" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">9</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-13" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">8</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-14" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">7</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-15" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">6</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-16" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">5</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-17" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">4</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="rqdScore-18" src="/images/report/unchecked.png" class="check" />
                                            <span class="point">3</span>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />

                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:180px" />
                                    <col style="width:auto" />
                                </colgroup>
                                <tr>
                                    <td class="border-weight border-right">
                                        ③ 절리면 간격
                                    </td>
                                    <td>2m이상</td>
                                    <td colspan="8">
                                        0.6-2m
                                    </td>
                                    <td colspan="4">
                                        0.2-0.6m
                                    </td>
                                    <td colspan="2">
                                        6-20cm
                                    </td>
                                    <td>6cm미만</td>
                                </tr>
                                <tr>
                                    <td class="score border-weight border-right">
                                        점수 (R3)
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-1"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">20</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-2"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">19</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-3"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">18</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-4"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">17</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-5"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">16</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-6"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">15</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-7"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">14</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-8"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">13</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-9"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">12</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-10"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">11</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-11"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">10</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-12"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">9</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-13"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">8</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-14"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">7</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-15"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">6</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="spacingJoinScore-16"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">5</span>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />

                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:50px" />
                                    <col style="width:130px" />
                                    <col style="width:auto" />
                                </colgroup>
                                <tr>
                                    <td rowspan="6">④<br />절리면<br />상태</td>
                                    <td class="border-weight border-right">불연속면의<br />길이 (연속성)</td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-persitence-1"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">1m 미만<br />6</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-persitence-2"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">1-3m<br />4</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-persitence-3"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">3-10m<br />2</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-persitence-4"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">10-20m<br />1</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-persitence-5"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">20m 이상<br />0</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">불연속면의<br />간격 (틈새)</td>
                                    <td>
                                        <div class="result">
                                            <img id="Ran-aperture-1" src="/images/report/unchecked.png" class="check" />
                                            <span class="point-title">없음<br />6</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="Ran-aperture-2" src="/images/report/unchecked.png" class="check" />
                                            <span class="point-title">0.1mm 이하<br />5</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="Ran-aperture-3" src="/images/report/unchecked.png" class="check" />
                                            <span class="point-title">0.1-1.0mm<br />4</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="Ran-aperture-4" src="/images/report/unchecked.png" class="check" />
                                            <span class="point-title">1-5mm<br />1</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img id="Ran-aperture-5" src="/images/report/unchecked.png" class="check" />
                                            <span class="point-title">5mm 이상<br />0</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">
                                        거칠기
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-roughness-1"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">매우 거침<br />(Very Rough)<br />6</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-roughness-2"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">거침<br />(Rough)<br />5</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-roughness-3"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">약간 거침<br />(Slightly Rough)<br />3</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-roughness-4"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">매끄러움<br />(Slickenside)<br />1</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-roughness-5"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">단층마찰면<br />(Fault Planar)<br />0</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td rowspan="2" class="border-weight border-right">
                                        충전물
                                    </td>
                                    <td rowspan="2">
                                        <div class="result">
                                            <img
                                                id="Ran-inFilling-1"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">없음<br />6</span>
                                        </div>
                                    </td>
                                    <td colspan="2">
                                        단단한 충전물
                                    </td>
                                    <td colspan="2">
                                        연약한 충전물
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-inFilling-2"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">5mm 미만<br />4</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-inFilling-3"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">5mm 이상<br />2</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-inFilling-4"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">5mm 미만<br />2</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-inFilling-5"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">5mm 이상<br />0</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">
                                        풍화정도
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-wallStrength-1"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">풍화안됨<br />(Frash)<br />6</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-wallStrength-2"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">약간 풍화<br />(Slightly Wathered)<br />5</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-wallStrength-3"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">풍화<br />(Moderately Wathered)<br />3</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-wallStrength-4"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">심한 풍화<br />(Hightly Wathered)<br />1</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="Ran-wallStrength-5"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point-title">
                                                파쇄(완전풍화)<br />(Completely Wathered)<br />0
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="score border-weight border-right">
                                        점수 (R4)
                                    </td>
                                    <td colspan="5">
                                        R4 (불연속면의 길이 + 불연속면의 간격 + 거칠기 + 충전물 + 풍화정도) =
                                        <span>
                                            {{ data.conditionJoinScore }}
                                        </span>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />

                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:50px" />
                                    <col style="width:130px" />
                                    <col style="width:auto" />
                                </colgroup>
                                <tr>
                                    <td rowspan="3">⑤<br />지하수</td>
                                    <td class="border-weight border-right">10m당<br />유입량</td>
                                    <td>없음</td>
                                    <td>10 (L/min)</td>
                                    <td>10-25(L/min)</td>
                                    <td>25-125(L/min)</td>
                                    <td>125초과(L/min)</td>
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">절리수압/<br />최대주응력</td>
                                    <td>0</td>
                                    <td>0.1미만</td>
                                    <td>0.1-0.2</td>
                                    <td>0.2-0.5</td>
                                    <td>0.5초과</td>
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">
                                        일반조건
                                    </td>
                                    <td>완전 건조<br />(Completely dry)</td>
                                    <td>습윤<br />(damp)</td>
                                    <td>젖어 있음<br />(wet)</td>
                                    <td>물방울 떨어짐<br />(dripping)</td>
                                    <td>물이 흐름<br />(flow)</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="score border-weight border-right">
                                        점수 (R5)
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="groundWaterRatioScore-1"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">15</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="groundWaterRatioScore-2"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">10</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="groundWaterRatioScore-3"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">7</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="groundWaterRatioScore-4"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">4</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="groundWaterRatioScore-5"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">0</span>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />

                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:180px" />
                                    <col style="width:auto" />
                                    <col style="width:auto" />
                                    <col style="width:auto" />
                                    <col style="width:auto" />
                                </colgroup>
                                <tr>
                                    <td rowspan="3" class="border-weight border-right">⑥ 절리방향에<br />따른 보정</td>
                                    <td colspan="4">
                                        주향이 터널방향과 수직
                                    </td>
                                    <td colspan="2" rowspan="2">주향이 터널 진행방향과<br />평행</td>
                                    <td rowspan="2">주향과<br />무관</td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        경사방향 굴진
                                    </td>
                                    <td colspan="2">
                                        역경사 방향 굴진
                                    </td>
                                </tr>
                                <tr>
                                    <td>45-90°</td>
                                    <td>20-45°</td>
                                    <td>45-90°</td>
                                    <td>20-45°</td>
                                    <td>45-90°</td>
                                    <td>20-45°</td>
                                    <td>0-20°</td>
                                </tr>
                                <tr>
                                    <td class="score border-weight border-right">
                                        점수 (R6)
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="orientationScore-1"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">0</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="orientationScore-2"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">- 2</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="orientationScore-3"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">- 5</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="orientationScore-4"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">- 10</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="orientationScore-5"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">- 12</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="orientationScore-6"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">- 5</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="result">
                                            <img
                                                id="orientationScore-7"
                                                src="/images/report/unchecked.png"
                                                class="check"
                                            />
                                            <span class="point">- 5</span>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />

                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:50px" />
                                    <col style="width:130px" />
                                    <col style="width:auto" />
                                </colgroup>
                                <tr>
                                    <td rowspan="3">암반<br />평가</td>
                                    <td class="border-weight border-right">RMR<br />평가</td>
                                    <td>100 - 81</td>
                                    <td>80 - 61</td>
                                    <td>60 - 41</td>
                                    <td>40 - 21</td>
                                    <td>20</td>
                                    <td>비고</td>
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">
                                        암반상태
                                    </td>
                                    <td>매우우수</td>
                                    <td>우 수</td>
                                    <td>양 호</td>
                                    <td>불 량</td>
                                    <td>매우불량</td>
                                    <td />
                                </tr>
                                <tr>
                                    <td class="border-weight border-right">
                                        TYPE
                                    </td>
                                    <td><img id="decideType-1" src="/images/report/unchecked.png" class="check" />Ⅰ</td>
                                    <td><img id="decideType-2" src="/images/report/unchecked.png" class="check" />Ⅱ</td>
                                    <td><img id="decideType-3" src="/images/report/unchecked.png" class="check" />Ⅲ</td>
                                    <td><img id="decideType-4" src="/images/report/unchecked.png" class="check" />Ⅳ</td>
                                    <td><img id="decideType-5" src="/images/report/unchecked.png" class="check" />Ⅴ</td>
                                    <td />
                                </tr>
                            </table>

                            <div class="table-gap" />

                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:180px" />
                                    <col style="width:auto" />
                                    <col style="width:180px" />
                                    <col style="width:auto" />
                                </colgroup>
                                <tr>
                                    <td class="score border-weight border-right">
                                        2. 총 점<br /><span class="normal small-font">(R1+R2+R3+R4+R5+R6)</span>
                                    </td>
                                    <td>{{ faceMappingStrength.rmrScore }}</td>
                                    <td class="score border-weight border-right">
                                        3. TYPE 결정
                                    </td>
                                    <td>
                                        {{ data.decisionRockType }}
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseB }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseB }" @click="isCloseB = !isCloseB">
                                <span>막장 Mapping</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <div class="table-gap" />
                            <table class="border-weight-all">
                                <colgroup>
                                    <col style="width:15%" />
                                    <col style="width:45%" />
                                    <col style="width:15%" />
                                    <col style="width:25%" />
                                </colgroup>
                                <tr>
                                    <th colspan="4" class="large-title">
                                        <span>막장 Mapping</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="inner-title">
                                        <span>현장명</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.constructionNameValue }}</span>
                                    </td>
                                    <th class="inner-title">
                                        <span>터널명</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.measureLocationName }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="inner-title">
                                        <span>위치</span>
                                    </th>
                                    <td class="inner-title">
                                        STA NO. <span>{{ data.station }}</span>
                                    </td>
                                    <th class="inner-title">
                                        <span>일자</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.investigationDay }} {{ data.investigationTime }}</span>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />
                            <table class="report td-center">
                                <colgroup>
                                    <col style="width:7%" />
                                    <col style="width:8%" />
                                    <col style="width: auto" />
                                </colgroup>
                                <tr>
                                    <td colspan="12" style="height:600px;">
                                        <div style="vertical-align: top;">
                                            <img src="/images/common/arrow.png" />
                                            <span>{{ data.bearing }}</span>
                                        </div>
                                        <img v-if="isMappingImage" :src="getMappingImage()" alt="" />
                                    </td>
                                </tr>
                                <tr>
                                    <td rowspan="2">
                                        범례
                                    </td>
                                    <td>암질</td>
                                    <td>단층대<br />파쇄대</td>
                                    <td>
                                        <img src="/images/common/pattern1.png" alt="" />
                                    </td>
                                    <td>경암</td>
                                    <td>
                                        <img src="/images/common/pattern2.png" alt="" />
                                    </td>
                                    <td>연암</td>
                                    <td>
                                        <img src="/images/common/pattern3.png" alt="" />
                                    </td>
                                    <td>풍화암</td>
                                    <td>
                                        <img src="/images/common/pattern4.png" alt="" />
                                    </td>
                                    <td>풍 화<br />잔류토</td>
                                    <td>
                                        <img src="/images/common/pattern5.png" alt="" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>절리<br />방향성</td>
                                    <td colspan="10" class="padding-none">
                                        <table class="border-bottom-none">
                                            <colgroup>
                                                <col style="width:35px" />
                                                <col style="width:auto" />
                                                <col style="width:35px" />
                                                <col style="width:auto" />
                                                <col style="width:35px" />
                                                <col style="width:auto" />
                                                <col style="width:35px" />
                                                <col style="width:auto" />
                                                <col style="width:35px" />
                                                <col style="width:auto" />
                                            </colgroup>
                                            <tr>
                                                <td>Ⅰ</td>
                                                <td><img src="/images/common/jully-d1.png" width="100" /></td>
                                                <td>Ⅱ</td>
                                                <td><img src="/images/common/jully-d2.png" width="100" /></td>
                                                <td>Ⅲ</td>
                                                <td><img src="/images/common/jully-d3.png" width="100" /></td>
                                                <td>Ⅳ</td>
                                                <td><img src="/images/common/jully-d4.png" width="100" /></td>
                                                <td>Ⅴ</td>
                                                <td><img src="/images/common/jully-d5.png" width="100" /></td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        특기사항
                                    </td>
                                    <td colspan="10" style="height:140px;" class="force-left">
                                        <pre>{{ data.description }}</pre>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        굴착현황
                                    </td>
                                    <td colspan="10" class="force-left">
                                        <pre>{{ data.faultShearZone }}</pre>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        RQD 산출근거
                                    </td>
                                    <td colspan="10" class="align-left">
                                        RQD = 115 - 3.3 × Jv = 115 - ( 3.3 × {{ data.jvCount }}) =
                                        {{ (115 - 3.3 * data.jvCount).toFixed(1) }}
                                    </td>
                                </tr>
                                <!-- 결재자 수만큼 균등 분할되는 2단(역할/서명) 서명란 -->
                                <tr>
                                    <td colspan="12" class="padding-none">
                                        <table class="sign-table">
                                            <tr class="sign-role-row">
                                                <td
                                                    v-for="(item, index) in signList"
                                                    :key="'role-' + index"
                                                    :style="{ width: signCellWidth }"
                                                >
                                                    {{ index === 0 ? '기 록 자' : '확 인 자' }}
                                                </td>
                                            </tr>
                                            <tr class="sign-row">
                                                <td
                                                    v-for="(item, index) in signList"
                                                    :id="'sign-' + (index + 1)"
                                                    :key="'sign-' + index"
                                                    class="sign"
                                                    :style="{ width: signCellWidth }"
                                                >
                                                    <span class="sign-name">{{ item.name }}</span>
                                                    <img
                                                        v-if="item.status === 'approval'"
                                                        class="sign-img"
                                                        :src="item.signUrl"
                                                    />
                                                    <span v-else class="sign-seal">(인)</span>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseC }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseC }" @click="isCloseC = !isCloseC">
                                <span>사진대지</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <div class="table-gap" />
                            <table class="border-weight-all">
                                <colgroup>
                                    <col style="width:15%" />
                                    <col style="width:45%" />
                                    <col style="width:15%" />
                                    <col style="width:25%" />
                                </colgroup>
                                <tr>
                                    <th class="inner-title">
                                        <span>현장명</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.constructionNameValue }}</span>
                                    </td>
                                    <th class="inner-title">
                                        <span>터널명</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.measureLocationName }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="inner-title">
                                        <span>위치</span>
                                    </th>
                                    <td class="inner-title">
                                        STA NO. <span>{{ data.station }}</span>
                                    </td>
                                    <th class="inner-title">
                                        <span>일자</span>
                                    </th>
                                    <td class="inner-title">
                                        <span>{{ data.investigationDay }} {{ data.investigationTime }}</span>
                                    </td>
                                </tr>
                            </table>

                            <div class="table-gap" />
                            <div class="photo-list-wrapper">
                                <div class="photo-list-box">
                                    <p class="tit">
                                        천단부
                                    </p>
                                    <div class="">
                                        <div class="ratio-type-1">
                                            <div v-if="data.topImageUrl" class="photo-img div-center">
                                                <img v-gallery:detail :src="fileUrl + data.topImageUrl" height="350" />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="photo-list-box">
                                    <p class="tit">
                                        막장면
                                    </p>
                                    <div class="photo-inbox-wrapper">
                                        <div class="photo-inbox ratio-type-1">
                                            <div v-if="data.frontImageUrl" class="photo-img height">
                                                <img
                                                    v-gallery:detail
                                                    :src="fileUrl + data.frontImageUrl"
                                                    :alt="fileUrl + data.frontImageUrl"
                                                />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="photo-list-box cnt-2">
                                    <p class="tit">
                                        좌측면
                                    </p>
                                    <div class="photo-inbox-wrapper cnt-2">
                                        <div class="photo-inbox ratio-type-2">
                                            <div v-if="data.leftImageUrl" class="photo-img height">
                                                <img v-gallery:detail :src="fileUrl + data.leftImageUrl" />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="photo-list-box cnt-2">
                                    <p class="tit">
                                        우측면
                                    </p>
                                    <div class="photo-inbox-wrapper cnt-2">
                                        <div class="photo-inbox ratio-type-2">
                                            <div v-if="data.rightImageUrl" class="photo-img height">
                                                <img
                                                    v-gallery:detail
                                                    :src="fileUrl + data.rightImageUrl"
                                                    :alt="fileUrl + data.rightImageUrl"
                                                />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-wrapper" style="margin-bottom: 61px;" data-html2canvas-ignore="true">
                        <button class="btn btn-delete" style="float:left" @click="modify()">
                            <span>수정으로</span>
                        </button>
                        <button class="btn btn-confirm" style="float:right" @click="list()">
                            <span>목록으로</span>
                        </button>
                    </div>

                    <div class="detail-box comment-box">
                        <div class="detail-contents">
                            <div class="detail-subheader">
                                <h3>Comment</h3>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: auto;" />
                                        <col style="width: 130px;" />
                                    </colgroup>
                                    <tr>
                                        <td>
                                            <textarea
                                                v-model="comment"
                                                class="comment"
                                                placeholder="댓글을 입력해주세요"
                                            />
                                        </td>
                                        <td>
                                            <button class="btn btn-confirm" @click="addComment()">
                                                <span>등록</span>
                                            </button>
                                        </td>
                                    </tr>
                                </table>

                                <span class="comment-count">총 {{ commentList.length }}개의 댓글이 있습니다.</span>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 150px;" />
                                        <col style="width: auto;" />
                                        <col style="width: 130px;" />
                                    </colgroup>
                                    <tr>
                                        <th class="force-center">
                                            작성자
                                        </th>
                                        <th>내용</th>
                                        <th>삭제</th>
                                    </tr>
                                    <tr v-for="(data, index) in commentList" :key="index">
                                        <td>
                                            {{ data.name }}<br />
                                            {{ data.regDt | formatTime }}
                                        </td>
                                        <td>
                                            <pre class="force-left">{{ data.content }}</pre>
                                        </td>
                                        <td>
                                            <button
                                                v-if="data.memberId === memberId || authType === 'admin'"
                                                class="btn btn-delete"
                                                @click="deleteComment(data.id)"
                                            >
                                                <span>삭제</span>
                                            </button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- // detail-wrapper -->
            </div>
        </div>
        <confirm :param="confirmParam" @confirmCallback="confirmCallback" />
    </body>

    <!-- // wrap -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ApprovalApi from '../../api/ApprovalApi';
import FacemappingApi from '../../api/FacemappingApi';
import { longFormatTime } from '../../utils/date';
import { FILE_URL, MEMBER_ID, TYPE } from './../../const';
import confirm from './../common/Confirm.vue';
import gnb from './../layout/gnb.vue';

export default {
    name: 'Detail',
    components: {
        gnb,
        confirm
    },
    data: () => {
        return {
            id: null,
            data: {
                rmrScore: 0
            },
            faceMappingSection: {},
            faceMappingStrength: {},
            groundWaterRatio: {},
            rmr: 0,

            isCloseA: false,
            isCloseB: false,
            isCloseC: false,
            gnbShow: '',
            fileUrl: FILE_URL,
            propTitle: '',
            approvalList: [],
            isSignBtn: false,
            isSignCancelBtn: false,
            authType: 'observer',
            memberId: '',
            confirmParam: {
                msg: '',
                isShow: false,
                callbackParam: {}
            },
            commentList: [],
            comment: ''
        };
    },
    computed: {
        ...mapState({}),
        /* 결재자가 없을 때는 기존 양식대로 기록자 + 확인자 2칸을 빈 칸으로 보여준다 */
        signList() {
            if (this.approvalList.length > 0) return this.approvalList;
            return [{ name: '' }, { name: '' }, { name: '' }];
        },
        signCellWidth() {
            return (100 / this.signList.length).toFixed(4) + '%';
        }
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
    },
    created() {
        this.id = this.$route.params.id;
    },
    mounted() {
        //ScreenHelper.setPortrait();
        this.dataObj();
        this.getCommentList();

        this.memberId = localStorage.getItem(MEMBER_ID);
        this.authType = localStorage.getItem(TYPE);
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        backbtn() {
            this.$router.go(-1);
        },
        list() {
            this.$router.push({
                name: 'List'
            });
        },
        modify() {
            this.$router.push({ path: `/step1/${this.id}` });
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        dataObj() {
            this.showLoading();
            this.isSignCancelBtn = false;
            this.isSignBtn = false;

            //data.approveState !== 'request'

            ApprovalApi.getLine(this.id).then(res => {
                this.approvalList = res.content;

                const waitingList = this.approvalList.filter(item => item.status === 'waiting');
                const approvalList = this.approvalList.filter(item => item.status === 'approval');

                if (waitingList.length > 0) {
                    if (waitingList[0].memberId === this.memberId) {
                        this.isSignBtn = true;
                    }
                }

                if (approvalList.length > 0) {
                    if (approvalList[approvalList.length - 1].memberId === this.memberId) {
                        this.isSignCancelBtn = true;
                    }
                }
            });

            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;

                this.propTitle =
                    res.content.constructionNameValue +
                    '/' +
                    res.content.measureLocationName +
                    '(' +
                    res.content.station +
                    ')';

                var strengthData = res.content.faceMappingStrength;

                $.each(strengthData, function(k, v) {
                    if (v) {
                        console.log(k + '-' + v);
                        $('#' + k + '-' + v).attr('src', '/images/report/check.png');
                    }
                });

                var sectionList = res.content.faceMappingSectionList;
                $.each(sectionList, function() {
                    var sectionDivisionCd = this.id.sectionDivisionCd;
                    $.each(this, function(k, v) {
                        if (sectionDivisionCd === 'Ran') {
                            if (k !== 'id') {
                                if (v) {
                                    $('#Ran-' + k + '-' + v).attr('src', '/images/report/check.png');
                                }
                            }
                        }
                    });
                });

                //this.faceMappingSection = sectionTempObj;

                if (strengthData !== null) {
                    this.faceMappingStrength = strengthData;
                    this.displayType(strengthData.rmrScore);
                }
                this.hideLoading();
            });
        },
        displayApproval(item) {
            let display = item.name;
            if (item.status === 'approval') {
                display += ' ' + longFormatTime(item.approvalDt);
            }
            return display;
        },
        signCancel() {
            var callbackParam = {};
            callbackParam.type = 'cancel';

            //var param = {};
            this.confirmParam.msg = '서명을 취소 하시겠습니까?';
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },
        sign() {
            var callbackParam = {};
            callbackParam.type = 'sign';

            //var param = {};
            this.confirmParam.msg = '서명 하시겠습니까?';
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },
        deleteComment(commentId) {
            var callbackParam = {
                commentId: commentId
            };
            callbackParam.type = 'commentDelete';
            this.confirmParam.msg = '댓글을 삭제 하시겠습니까?';
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },
        addComment() {
            var callbackParam = {};
            callbackParam.type = 'addComment';
            this.confirmParam.msg = '댓글을 등록 하시겠습니까?';
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },
        confirmCallback(callbackParam) {
            console.log(callbackParam);
            if (callbackParam.type === 'sign') {
                var param = {
                    masterId: this.id,
                    status: 'approval',
                    approvalMsg: null
                };

                ApprovalApi.sign(param).then(() => {
                    this.dataObj();
                });
            }
            if (callbackParam.type === 'cancel') {
                ApprovalApi.cancelSign(this.id).then(() => {
                    this.dataObj();
                });
            }
            if (callbackParam.type === 'commentDelete') {
                FacemappingApi.deleteComment(callbackParam.commentId).then(() => {
                    this.getCommentList();
                });
            }
            if (callbackParam.type === 'addComment') {
                var param2 = {
                    masterId: this.id,
                    content: this.comment,
                    id: null
                };

                FacemappingApi.postComment(param2).then(() => {
                    this.comment = '';
                    this.getCommentList();
                });
            }
        },
        getCommentList() {
            FacemappingApi.getCommentList(this.id).then(res => {
                this.commentList = res.content;
            });
        },
        getMappingImage() {
            //return this.data.threeDimensionalImageUrl || this.data.rockJudgmentImageUrl;
            return this.data.rockJudgmentImageUrl;
        },
        isMappingImage() {
            return this.getMappingImage() !== null;
        },
        displayType(rmrScore) {
            var type = 5;
            if (rmrScore >= 81) {
                type = 1;
            } else if (rmrScore >= 61) {
                type = 2;
            } else if (rmrScore >= 41) {
                type = 3;
            } else if (rmrScore >= 21) {
                type = 4;
            } else {
                type = 5;
            }

            $('#decideType-' + type).attr('src', '/images/report/check.png');
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
